<template>
  <svg width="100%" height="100%" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
       class="fill-current">
    <path
      d="M6.5 1.25H6.125V1.25C3.43261 1.25 1.25 3.43261 1.25 6.125V8C1.25 9.62772 1.25 10.4416 1.43772 11.1072C1.90993 12.7815 3.21847 14.0901 4.8928 14.5623C5.55842 14.75 6.37228 14.75 8 14.75H9.875C12.5674 14.75 14.75 12.5674 14.75 9.875V9.875V9.5M8 8L14.75 1.25M14.75 1.25H10.25M14.75 1.25V5.75"
      fill="none" stroke="currentColor" stroke-width="1.245" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'OpenInNewIcon'
}
</script>

<style scoped lang="scss">

</style>
